import { Sprite, Texture } from 'pixi.js';
import type { Tween } from '../../../../libs/TweenManager/Tween';

export enum TileStackHighlightDisplayMode {
  Normal,
  Tall,
}

export class TileStackHighlight extends Sprite {
  #displayMode!: TileStackHighlightDisplayMode;

  private highlightTween: Tween | undefined;

  private active = false;

  constructor() {
    super();
    this.displayMode = TileStackHighlightDisplayMode.Normal;
    this.alpha = 0;
    this.anchor.set(0.5, 0.5);
    this.interactive = false;
    this.interactiveChildren = false;
  }

  set displayMode(mode: TileStackHighlightDisplayMode) {
    if (this.#displayMode === mode) return;

    switch (mode) {
      case TileStackHighlightDisplayMode.Tall:
        this.texture = Texture.from('stack_highlight');
        this.anchor.y = 0.7;
        break;
      default:
        this.texture = Texture.from('tile_hover');
        this.anchor.y = 0.5;
        break;
    }
    this.#displayMode = mode;
  }

  public setDisplayMode(mode: TileStackHighlightDisplayMode): this {
    this.displayMode = mode;
    return this;
  }

  public show(duration = 250, delay = 0): void {
    if (this.active && duration > 0) return;
    this.active = true;

    this.highlightTween?.stop();
    if (duration > 0) {
      this.highlightTween = this.tweenTo({ alpha: 1 }, duration, 'quadOut', true, delay);
    } else {
      this.alpha = 1;
    }
  }

  public hide(duration = 250, delay = 0): void {
    if (!this.active && duration > 0) return;
    this.active = false;

    this.highlightTween?.stop();
    if (duration > 0) {
      this.highlightTween = this.tweenTo({ alpha: 0 }, duration, 'quadOut', true, delay);
    } else {
      this.alpha = 0;
    }
  }
}
